// import React, {useEffect, useState} from 'react';
// import {v3_upload_document} from '../../../actions/v3/document';
// import {FaPlus, FaTrash} from 'react-icons/fa';
// import {validateFunctionalForm} from '../../../utils';
// import {
//     v3_add_inspection_attendance,
//     v3_edit_inspection_attendance,
// } from '../../../actions/v3/inspection';
// import {toast} from 'react-toastify';
//
// const AttendanceForm = ({data, setRefresh, refresh, attendenceData = null}) => {
//     const isEdit = !!attendenceData;
//
//     const [state, setState] = useState({
//         result: {
//             name: 'result',
//             value: attendenceData ? attendenceData.RESULT : '',
//             options: [
//                 'Scheduled',
//                 'In Progress',
//                 'Passed',
//                 'Failed',
//                 'Succeeded',
//                 'Rejected',
//                 'Rescheduled',
//                 'Cancelled',
//             ],
//             isRequired: false,
//             error: '',
//         },
//         remarks: {
//             name: 'remarks',
//             value: attendenceData ? attendenceData.REMARK : '',
//             isRequired: true,
//             error: '',
//         },
//         documentFiles: {
//             // used only on CREATE
//             name: 'documentFiles',
//             value: [{fileName: '', originalFileName: ''}],
//             isRequired: false,
//             error: '',
//         },
//         status: {
//             name: 'status',
//             value: '',
//             error: '',
//             options: ['Unscheduled', 'Scheduled', 'In Progress', 'Accepted', 'Rejected', 'Cancelled'],
//             isRequired: false,
//         },
//     });
//
//     // existing docs on EDIT
//     const [existingDocs, setExistingDocs] = useState(
//         attendenceData?.documents || []
//     );
//     const [docsToDelete, setDocsToDelete] = useState([]); // array of doc IDs
//     const [newDocs, setNewDocs] = useState([]); // uploaded when editing
//
//     useEffect(() => {
//         if (attendenceData) {
//             setState((prev) => ({
//                 ...prev,
//                 result: {
//                     ...prev.result,
//                     value: attendenceData.RESULT,
//                 },
//                 remarks: {
//                     ...prev.remarks,
//                     value: attendenceData.REMARK,
//                 },
//             }));
//             setExistingDocs(attendenceData.documents || []);
//             setDocsToDelete([]);
//             setNewDocs([]);
//         }
//     }, [attendenceData]);
//
//     const handleChange = (e) => {
//         const {name, value} = e.target;
//         setState((prev) => ({
//             ...prev,
//             [name]: {...prev[name], value},
//         }));
//     };
//
//     // CREATE: upload into state.documentFiles
//     const handleFileChangeCreate = (index, file) => {
//         const formData = new FormData();
//         formData.append('file', file);
//
//         v3_upload_document(formData).then((res) => {
//             if (res.status && res.result) {
//                 const updatedFiles = [...state.documentFiles.value];
//                 updatedFiles[index] = {
//                     fileName: res.result.fileName,
//                     originalFileName: res.result.originalFileName,
//                 };
//
//                 setState((prev) => ({
//                     ...prev,
//                     documentFiles: {
//                         ...prev.documentFiles,
//                         value: updatedFiles,
//                         error: updatedFiles.length === 0 ? 'This field is required' : '',
//                     },
//                 }));
//             }
//         });
//     };
//
//     const addFileField = () => {
//         setState((prev) => ({
//             ...prev,
//             documentFiles: {
//                 ...prev.documentFiles,
//                 value: [
//                     ...prev.documentFiles.value,
//                     {fileName: '', originalFileName: ''},
//                 ],
//                 error: '',
//             },
//         }));
//     };
//
//     const removeFileField = (index) => {
//         const updatedFiles = state.documentFiles.value.filter((_, i) => i !== index);
//         setState((prev) => ({
//             ...prev,
//             documentFiles: {
//                 ...prev.documentFiles,
//                 value: updatedFiles,
//                 error:
//                     updatedFiles.length === 0 ? 'At least one document is required' : '',
//             },
//         }));
//     };
//
//     // EDIT: upload new docs to attach
//     const handleFileChangeEdit = (file) => {
//         const formData = new FormData();
//         formData.append('file', file);
//
//         v3_upload_document(formData).then((res) => {
//             if (res.status && res.result) {
//                 setNewDocs((prev) => [
//                     ...prev,
//                     {
//                         fileName: res.result.fileName,
//                         originalFileName: res.result.originalFileName,
//                     },
//                 ]);
//             }
//         });
//     };
//
//     const toggleDeleteExisting = (docId) => {
//         setDocsToDelete((prev) =>
//             prev.includes(docId) ? prev.filter((id) => id !== docId) : [...prev, docId]
//         );
//     };
//
//     const handleSubmit = () => {
//         if (validateFunctionalForm(state, setState)) {
//             if (isEdit) {
//                 const model = {
//                     remarks: state.remarks.value,
//                     result: state.result.value,
//                     inspectionId: data.ID,
//                     attendanceId: attendenceData.ID,
//                     // NEW: docs to attach + ids to delete
//                     files: newDocs, // [{ fileName, originalFileName }]
//                     deleteDocumentIds: docsToDelete, // [id, id, ...]
//                 };
//
//                 v3_edit_inspection_attendance(model).then((res) => {
//                     if (res.status) {
//                         const modal = window.bootstrap.Modal.getInstance(
//                             document.getElementById('newAttendanceModalEdit')
//                         );
//                         if (modal) modal.hide();
//                         toast.success(res.result.message);
//                         setRefresh(!refresh);
//                     }
//                 });
//             } else {
//                 const model = {
//                     remarks: state.remarks.value,
//                     result: state.result.value,
//                     inspectionId: data.ID,
//                     files: state.documentFiles.value,
//                     status: state.status.value,
//                 };
//
//                 v3_add_inspection_attendance(model).then((res) => {
//                     if (res.status) {
//                         const modal = window.bootstrap.Modal.getInstance(
//                             document.getElementById('newAttendanceModal')
//                         );
//                         if (modal) modal.hide();
//                         toast.success(res.result.message);
//                         setRefresh(!refresh);
//                         setState((prev) => ({
//                             ...prev,
//                             remarks: {...prev.remarks, value: ''},
//                             result: {...prev.result, value: ''},
//                             documentFiles: {
//                                 ...prev.documentFiles,
//                                 value: [{fileName: '', originalFileName: ''}],
//                             },
//                         }));
//                     }
//                 });
//             }
//         }
//     };
//
//     const handleCancel = () => {
//         const id = isEdit ? 'newAttendanceModalEdit' : 'newAttendanceModal';
//         const modal = window.bootstrap.Modal.getInstance(document.getElementById(id));
//         if (modal) modal.hide();
//     };
//
//     return (
//         <>
//             <div className="row">
//                 <div className="col-md-12 mb-3">
//                     <label>
//                         Result <span>*</span>
//                     </label>
//                     <select
//                         name={'result'}
//                         value={state['result'].value}
//                         onChange={handleChange}
//                         className={`form-select ${state['result'].error ? 'is-invalid' : ''}`}
//                     >
//                         <option value={''}>Select Result</option>
//                         {state.result.options.map((result) => (
//                             <option key={result} value={result}>
//                                 {result}
//                             </option>
//                         ))}
//                     </select>
//
//                     {state['result'].error && (
//                         <div className="invalid-feedback">{state['result'].error}</div>
//                     )}
//                 </div>
//
//                 <div className="col-md-12 mb-3">
//                     <label>Comment</label>
//                     <textarea
//                         row="2"
//                         name={'remarks'}
//                         placeholder="Enter Comment"
//                         value={state['remarks'].value}
//                         onChange={handleChange}
//                         className={`form-control ${
//                             state['remarks'].error ? 'is-invalid' : ''
//                         }`}
//                     />
//                     {state['remarks'].error && (
//                         <div className="invalid-feedback">{state['remarks'].error}</div>
//                     )}
//                 </div>
//
//                 {/* CREATE: upload docs (your existing UI) */}
//                 {!isEdit && (
//                     <div className="col-md-12 mb-3 ">
//                         <div className="input-form ">
//                             <div className="label-form mb-2">Upload Documents</div>
//
//                             {state.documentFiles.value.map((item, index) => (
//                                 <div key={index} className="d-flex align-items-center mb-2">
//                                     {item.fileName ? (
//                                         <>
//                                             <div className="me-2 flex-grow-1">
//                                                 <span>{item.originalFileName}</span>
//                                             </div>
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-outline-danger"
//                                                 onClick={() => removeFileField(index)}
//                                             >
//                                                 <FaTrash/>
//                                             </button>
//                                         </>
//                                     ) : (
//                                         <>
//                                             <input
//                                                 type="file"
//                                                 onChange={(e) =>
//                                                     handleFileChangeCreate(index, e.target.files[0])
//                                                 }
//                                                 className="form-control me-2"
//                                             />
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-outline-danger"
//                                                 onClick={() => removeFileField(index)}
//                                             >
//                                                 <FaTrash/>
//                                             </button>
//                                         </>
//                                     )}
//                                 </div>
//                             ))}
//
//                             <div>
//                                 <button
//                                     type="button"
//                                     className="btn btn-outline-primary"
//                                     onClick={addFileField}
//                                 >
//                                     <FaPlus className="me-1"/> Add Document
//                                 </button>
//                             </div>
//
//                             {state.documentFiles.error && (
//                                 <div className="text-danger mt-1">
//                                     {state.documentFiles.error}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 )}
//
//                 {/* EDIT: existing + new docs */}
//                 {isEdit && (
//                     <>
//                         <div className="col-md-12 mb-3">
//                             <div className="label-form mb-2">Existing Documents</div>
//                             {existingDocs.length === 0 ? (
//                                 <p className="text-muted">No documents attached.</p>
//                             ) : (
//                                 existingDocs.map((doc) => (
//                                     <div
//                                         key={doc.ID}
//                                         className="d-flex align-items-center justify-content-between mb-2"
//                                     >
//                                         <div>
//                       <span
//                           style={{
//                               textDecoration: docsToDelete.includes(doc.ID)
//                                   ? 'line-through'
//                                   : 'none',
//                           }}
//                       >
//                         {doc.ORIGINAL_FILE_NAME}
//                       </span>
//                                             <a
//                                                 href={`${process.env.REACT_APP_BASE_URL}/v3/inspection/attendance/download/${data.ID}/${attendenceData.ID}/${doc.FILE_NAME}`}
//                                                 target="_blank"
//                                                 rel="noreferrer"
//                                                 className="btn btn-sm btn-link ms-2"
//                                             >
//                                                 View
//                                             </a>
//
//                                             {docsToDelete.includes(doc.ID) && (
//                                                 <span className="badge bg-danger ms-2">
//                           Will be deleted
//                         </span>
//                                             )}
//                                         </div>
//                                         <button
//                                             type="button"
//                                             className="btn btn-outline-danger btn-sm"
//                                             onClick={() => toggleDeleteExisting(doc.ID)}
//                                         >
//                                             {docsToDelete.includes(doc.ID) ? 'Undo' : <FaTrash/>}
//                                         </button>
//                                     </div>
//                                 ))
//                             )}
//                         </div>
//
//                         <div className="col-md-12 mb-3">
//                             <div className="label-form mb-2">Add Documents</div>
//                             <input
//                                 type="file"
//                                 className="form-control"
//                                 onChange={(e) => {
//                                     if (e.target.files && e.target.files[0]) {
//                                         handleFileChangeEdit(e.target.files[0]);
//                                         // reset so same file can be picked again if needed
//                                         e.target.value = '';
//                                     }
//                                 }}
//                             />
//                             {newDocs.length > 0 && (
//                                 <ul className="mt-2">
//                                     {newDocs.map((doc, idx) => (
//                                         <li key={idx}>{doc.originalFileName}</li>
//                                     ))}
//                                 </ul>
//                             )}
//                         </div>
//                     </>
//                 )}
//             </div>
//
//             <div className="mt-3">
//                 <button
//                     type="submit"
//                     className="btn btn-success me-2"
//                     onClick={handleSubmit}
//                 >
//                     Submit
//                 </button>
//                 <button
//                     type="button"
//                     className="btn btn-danger text-white"
//                     onClick={handleCancel}
//                 >
//                     Cancel
//                 </button>
//             </div>
//         </>
//     );
// };
//
// export default AttendanceForm;

import React, { useEffect, useState } from 'react';
import { v3_upload_document } from '../../../actions/v3/document';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { validateFunctionalForm } from '../../../utils';
import {
    v3_add_inspection_attendance,
    v3_edit_inspection_attendance,
} from '../../../actions/v3/inspection';
import { toast } from 'react-toastify';
import RemarksSelect from '../../common/RemarksSelect';
import { uploadSelectedFiles } from '../../../utils/multipleFileUpload';

const decodeMojibake = (value) => {
    if (!value) return value;
    if (!/[\u00C0-\u00FF]/.test(value)) return value;
    try {
        const bytes = Uint8Array.from(value, (ch) => ch.charCodeAt(0));
        const decoded = new TextDecoder('utf-8').decode(bytes);
        if (decoded.includes('�') && !value.includes('�')) return value;
        return decoded || value;
    } catch (error) {
        return value;
    }
};

const getUploadedFiles = (files = []) => (
    Array.isArray(files)
        ? files.filter((file) => file?.fileName && file?.originalFileName)
        : []
);

const AttendanceForm = ({ data, setRefresh, refresh, attendenceData = null }) => {
    const isEdit = !!attendenceData;

    const [state, setState] = useState({
        result: {
            name: 'result',
            value: attendenceData ? attendenceData.RESULT : '',
            options: [
                'Unscheduled',
                'Scheduled',
                'In Progress',
                'Accepted',
                'Rejected',
                'Cancelled',
                'Re-Inspection'
            ],
            isRequired: false,
            error: '',
        },
        remarks: {
            name: 'remarks',
            value: attendenceData ? attendenceData.REMARK : '',
            isRequired: true,
            error: '',
        },
        documentFiles: {
            // used only on CREATE
            name: 'documentFiles',
            value: [{ fileName: '', originalFileName: '' }],
            isRequired: false,
            error: '',
        },
        status: {
            name: 'status',
            value: '',
            error: '',
            options: ['Unscheduled', 'Scheduled', 'In Progress', 'Accepted', 'Rejected', 'Cancelled', 'Re-Inspection'],
            isRequired: false,
        },
    });

    // existing docs on EDIT
    const [existingDocs, setExistingDocs] = useState(attendenceData?.documents || []);
    const [docsToDelete, setDocsToDelete] = useState([]); // array of doc IDs
    const [newDocs, setNewDocs] = useState([]); // uploaded when editing

    useEffect(() => {
        if (attendenceData) {
            setState((prev) => ({
                ...prev,
                result: {
                    ...prev.result,
                    value: attendenceData.RESULT,
                },
                remarks: {
                    ...prev.remarks,
                    value: attendenceData.REMARK,
                },
            }));
            setExistingDocs(attendenceData.documents || []);
            setDocsToDelete([]);
            setNewDocs([]);
        }
    }, [attendenceData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: { ...prev[name], value },
        }));
    };

    // CREATE: upload into state.documentFiles
    const handleFileChangeCreate = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_document);
        if (!uploadedFiles.length) {
            toast.error('Failed to upload document');
            return;
        }

        setState((prev) => {
            const updatedFiles = [...prev.documentFiles.value];
            updatedFiles.splice(index, 1, ...uploadedFiles);
            return {
                ...prev,
                documentFiles: { ...prev.documentFiles, value: updatedFiles, error: '' },
            };
        });
    };

    const addFileField = () => {
        setState((prev) => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: [...prev.documentFiles.value, { fileName: '', originalFileName: '' }],
                error: '',
            },
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.documentFiles.value.filter((_, i) => i !== index);
        setState((prev) => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: updatedFiles,
                error:
                    updatedFiles.length === 0 ? 'At least one document is required' : '',
            },
        }));
    };

    // EDIT: upload new docs to attach
    const handleFileChangeEdit = async (files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_document);
        if (!uploadedFiles.length) {
            toast.error('Failed to upload document');
            return;
        }
        setNewDocs((prev) => [...prev, ...uploadedFiles]);
    };

    const toggleDeleteExisting = (docId) => {
        setDocsToDelete((prev) =>
            prev.includes(docId) ? prev.filter((id) => id !== docId) : [...prev, docId]
        );
    };

    const handleSubmit = () => {
        if (!validateFunctionalForm(state, setState)) return;

        if (isEdit) {
            const model = {
                remarks: state.remarks.value,
                result: state.result.value,
                inspectionId: data.ID,          // needed for folder path on backend
                attendanceId: attendenceData.ID,
                files: newDocs,                 // [{ fileName, originalFileName }]
                deleteDocumentIds: docsToDelete // [ID, ID, ...]
            };

            v3_edit_inspection_attendance(model)
                .then((res) => {
                    if (res.status) {
                        const modal = window.bootstrap.Modal.getInstance(
                            document.getElementById('newAttendanceModalEdit')
                        );
                        if (modal) modal.hide();
                        toast.success(res.result.message);
                        setRefresh(!refresh);
                        setDocsToDelete([]);
                        setNewDocs([]);
                    } else {
                        toast.error(res?.result?.message || 'Failed to update attendance');
                    }
                })
                .catch((err) => {
                    console.error(err);
                    toast.error('Something went wrong while updating attendance');
                });
        } else {
            const uploadedFiles = getUploadedFiles(state.documentFiles.value);
            const model = {
                remarks: state.remarks.value,
                result: state.result.value,
                inspectionId: data.ID,
                files: uploadedFiles,
                status: state.status.value,
            };

            v3_add_inspection_attendance(model)
                .then((res) => {
                    if (res.status) {
                        const modal = window.bootstrap.Modal.getInstance(
                            document.getElementById('newAttendanceModal')
                        );
                        if (modal) modal.hide();
                        toast.success(res.result.message);
                        setRefresh(!refresh);
                        setState((prev) => ({
                            ...prev,
                            remarks: { ...prev.remarks, value: '' },
                            result: { ...prev.result, value: '' },
                            documentFiles: {
                                ...prev.documentFiles,
                                value: [{ fileName: '', originalFileName: '' }],
                            },
                        }));
                    } else {
                        toast.error(res?.result?.message || 'Failed to create attendance');
                    }
                })
                .catch((err) => {
                    console.error(err);
                    toast.error('Something went wrong while creating attendance');
                });
        }
    };

    const handleCancel = () => {
        const id = isEdit ? 'newAttendanceModalEdit' : 'newAttendanceModal';
        const modal = window.bootstrap.Modal.getInstance(document.getElementById(id));
        if (modal) modal.hide();
    };

    return (
        <>
            <div className="row">
                <div className="col-md-12 mb-3">
                    <label>
                        Result <span>*</span>
                    </label>
                    <select
                        name={'result'}
                        value={state['result'].value}
                        onChange={handleChange}
                        className={`form-select ${state['result'].error ? 'is-invalid' : ''}`}
                    >
                        <option value={''}>Select Result</option>
                        {state.result.options.map((result) => (
                            <option key={result} value={result}>
                                {result}
                            </option>
                        ))}
                    </select>

                    {state['result'].error && (
                        <div className="invalid-feedback">{state['result'].error}</div>
                    )}
                </div>

                <RemarksSelect
                    label="Comment"
                    name="remarks"
                    value={state.remarks.value}
                    onChange={handleChange}
                    error={state.remarks.error}
                    required={state.remarks.isRequired}
                    placeholder="Enter comment"
                />

                {/* CREATE: upload docs */}
                {!isEdit && (
                    <div className="col-md-12 mb-3 ">
                        <div className="input-form ">
                            <div className="label-form mb-2">Upload Documents</div>

                            {state.documentFiles.value.map((item, index) => (
                                <div key={index} className="d-flex align-items-center mb-2">
                                    {item.fileName ? (
                                        <>
                                            <div className="me-2 flex-grow-1">
                                                <span>{decodeMojibake(item.originalFileName || item.fileName)}</span>
                                            </div>
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger"
                                                onClick={() => removeFileField(index)}
                                            >
                                                <FaTrash />
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <input
                                                type="file"
                                                multiple
                                                onChange={(e) =>
                                                    handleFileChangeCreate(index, e.target.files)
                                                }
                                                className="form-control me-2"
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger"
                                                onClick={() => removeFileField(index)}
                                            >
                                                <FaTrash />
                                            </button>
                                        </>
                                    )}
                                </div>
                            ))}

                            <div>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    onClick={addFileField}
                                >
                                    <FaPlus className="me-1" /> Add Document
                                </button>
                            </div>

                            {state.documentFiles.error && (
                                <div className="text-danger mt-1">
                                    {state.documentFiles.error}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* EDIT: existing + new docs */}
                {isEdit && (
                    <>
                        <div className="col-md-12 mb-3">
                            <div className="label-form mb-2">Existing Documents</div>
                            {existingDocs.length === 0 ? (
                                <p className="text-muted">No documents attached.</p>
                            ) : (
                                existingDocs.map((doc) => (
                                    <div
                                        key={doc.ID}
                                        className="d-flex align-items-center justify-content-between mb-2"
                                    >
                                        <div>
                      <span
                          style={{
                              textDecoration: docsToDelete.includes(doc.ID)
                                  ? 'line-through'
                                  : 'none',
                          }}
                      >
                        {decodeMojibake(doc.ORIGINAL_FILE_NAME || doc.FILE_NAME)}
                      </span>

                                            {/* View link using backend download route */}
                                            <a
                                                href={`${process.env.REACT_APP_BASE_URL}/v3/inspection/attendance/preview/${data.ID}/${attendenceData.ID}/${doc.FILE_NAME}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-sm btn-link ms-2"
                                            >
                                                View
                                            </a>

                                            {docsToDelete.includes(doc.ID) && (
                                                <span className="badge bg-danger ms-2">
                          Will be deleted
                        </span>
                                            )}
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => toggleDeleteExisting(doc.ID)}
                                        >
                                            {docsToDelete.includes(doc.ID) ? 'Undo' : <FaTrash />}
                                        </button>
                                    </div>
                                ))
                            )}
                        </div>

                        <div className="col-md-12 mb-3">
                            <div className="label-form mb-2">Add Documents</div>
                            <input
                                type="file"
                                multiple
                                className="form-control"
                                onChange={(e) => {
                                    if (e.target.files?.length) {
                                        handleFileChangeEdit(e.target.files);
                                        // reset so same file can be picked again if needed
                                        e.target.value = '';
                                    }
                                }}
                            />
                            {newDocs.length > 0 && (
                                <ul className="mt-2">
                                    {newDocs.map((doc, idx) => (
                                        <li key={idx}>{decodeMojibake(doc.originalFileName || doc.fileName)}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </>
                )}
            </div>

            <div className="mt-3">
                <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={handleSubmit}
                >
                    Submit
                </button>
                <button
                    type="button"
                    className="btn btn-danger text-white"
                    onClick={handleCancel}
                >
                    Cancel
                </button>
            </div>
        </>
    );
};

export default AttendanceForm;
